/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queues_Waiting_On_OthersInputs */

const en_queues_waiting_on_others = /** @type {(inputs: Queues_Waiting_On_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on others`)
};

/**
* | output |
* | --- |
* | "Waiting on others" |
*
* @param {Queues_Waiting_On_OthersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queues_waiting_on_others = /** @type {((inputs?: Queues_Waiting_On_OthersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queues_Waiting_On_OthersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queues_waiting_on_others(inputs)
});